var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgReplyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 9,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.405 4.563C2.792 3.185 4.767 3.017 5.42 3V.215c0-.119.092-.215.207-.215.056 0 .109.023.148.063L9.94 4.349a.219.219 0 0 1 0 .303L5.775 8.937a.204.204 0 0 1-.294 0 .217.217 0 0 1-.061-.151V6.008c-.902.046-4.42.356-5.006 2.41a.207.207 0 0 1-.258.145.214.214 0 0 1-.15-.206 5.132 5.132 0 0 1 1.399-3.794Z",
  fill: "#D1D3DA"
})));
export { SvgReplyIcon as ReactComponent };
export default __webpack_public_path__ + "e3a25c568e839ab49bca47e9bcd6c449.svg";